<template>
    <div class="row">
        <div class="col-md-6 mb-1">
            <label class="form-label">Verildiği İl</label>
            <v-select-list v-model="province" :options="provinces" label="Name" v-on:input="getDistricts" placeholder="Verildiği il"></v-select-list>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Verildiği İlçe</label>
            <v-select-list :disabled="!province" v-model="district" :options="districts" label="Name" placeholder="Verildiği ilçe"></v-select-list>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">İlk Tescil Tarihi</label>
            <flat-pickr v-model="value.FirstRegistrationDate" class="form-control" :config="{altInput:true, altFormat:'d.m.Y',dateFormat: 'Y-m-d',maxDate:'today', locale:'tr'}" placeholder="Tarih Seçiniz"/>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Tescil Tarihi</label>
            <flat-pickr v-model="value.RegistrationDate" class="form-control" :config="{altInput:true, altFormat:'d.m.Y',dateFormat: 'Y-m-d' , locale:'tr'}" placeholder="Tarih Seçiniz"/>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Tescil Sıra No</label>
            <input v-model="value.RegistrationOrderNo" class="form-control" type="text" placeholder="Tescil Sıra No" />
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Motor No</label>
            <input v-model="value.MotorNo" class="form-control" type="text" placeholder="Motor No" />
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Şasi No</label>
            <input v-model="value.ChasisNo" class="form-control" type="text" placeholder="Şasi No" />
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Belge No</label>
            <input v-model="value.DocumentNo" class="form-control" type="text" placeholder="Belge No" />
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/l10n/tr.js'

export default {
    components:{
        flatPickr
    },
    props:{
        value:Object
    },
    data(){
        return{
            provinces:[],
            districts:[],
        }
    },  
    mounted(){
        this.getProvinces()
    },
    watch:{
        "value.ProvinceId":function(newValue,oldValue){
            this.value.DistrictId = null
        }
    },
    methods:{
        getProvinces(){
            SystemDataApi.Province().then(response=>{
                this.provinces = response.data.Data
            })
        },
        getDistricts(){
            return new Promise((resolve)=>{
                if(this.value.ProvinceId){
                    SystemDataApi.District(this.value.ProvinceId)
                    .then(res=>{
                        this.districts = res.data.Data
                        resolve()
                    })
                }
            })
        }
    },
    computed:{
        province:{
            get:function(){
                return this.provinces.find(b=>b.Id==this.value.ProvinceId)
            },
            set:function(value){
                this.value.ProvinceId = value?.Id || this.value.ProvinceId
            }
        },
        district:{
            get:function(){
                return this.districts.find(b=>b.Id==this.value.DistrictId)
            },
            set:function(value){
                this.value.DistrictId = value?.Id || this.value.DistrictId
            }
        },
    }
}
</script>
